import style from "./style.module.css";
import video from "../../../assets/video.svg";
import search from "../../../assets/search.svg";
import reload from "../../../assets/reload.svg";
import plus from "../../../assets/plus.svg";
import pdf from "../../../assets/pdf.svg";
import { Link } from "react-router-dom";
import { useContext } from "react";
import StoreContext from "../../../context/store";
import { getAnnouncementPdf } from "../../../api/general";

const Bar = () => {
  const { setAddAnnouncementClick, setAnnouncementInputValue, announcementInputValue } =
    useContext(StoreContext);

  const getAnnouncementPdfMethod = async () => {
    const response = await getAnnouncementPdf();
    if (response.error) {
      console.log("Öğretmen pdfi gelmedi");
      console.log(response.error, "response.erro");
    } else {
      console.log("Öğretmen pdfi geldi");
    }
  };

  return (
    <div className={style.container}>
      <div className={style.announcements}>
        <div className={style.announcementstext}>Duyurular</div>
        <Link>
          <img alt="" className={style.announcementsvideo} src={video}></img>
        </Link>
      </div>
      <div className={style.search}>
        <button className={style.searchicon}>
          <img alt="" src={search}></img>
        </button>
        <input
          className={style.searchinput}
          placeholder="Ara"
          onChange={(e) => {
            setAnnouncementInputValue(e.target.value);
          }}
          value={announcementInputValue}
        ></input>
      </div>
      <button
        onClick={() => {
          window.location.reload();
        }}
      >
        <img alt="" className={style.reload} src={reload}></img>
      </button>
      <div className={style.tabs}>
        <div className={style.tab}>
          <button
            className={style.tabicon}
            onClick={() => {
              setAddAnnouncementClick(true);
            }}
          >
            <img alt="" src={plus}></img>
          </button>
          <div className={style.tabtext}>Yeni Duyuru</div>
        </div>
        <div className={style.tab}>
          <button
            className={style.tabicon}
            onClick={() => {
           //   getAnnouncementPdfMethod();
            }}
          >
            <img alt="" src={pdf}></img>
          </button>
          <div className={style.tabtext}>PDF Yazdır</div>
        </div>
      </div>
    </div>
  );
};

export default Bar;
